export default __webpack_public_path__ + "static/media/black_brawn.8baee041.png";